import Image from 'next/image';

type Props = {
    src: string
    alt: string
    text: string
    title: string
}

const textRandom = [
    "احساس رایحه، لمس طراوت",
    "سفری به دنیای عطرهای ناب",
    "جزیره‌ای از رایحه‌های اصیل و خاص",
    "انتخابی برای تمام سلیقه‌ها",
    "با هر عطر، داستانی جدید",
    "حس تازگی، تجربه بی‌نظیر",
    "رایحه‌ای که هویت شما را منعکس می‌کند",
    "جزیره‌ای از رایحه‌های شگفت‌انگیز",
    "نفس کشیدن در جزیره عطر",
    "ترکیبی از اصالت و نوآوری در هر قطره",
]

const DynamicImage = ({ src, alt, title, text }: Props) => {
    return (
        <div className="relative w-full h-[400px] overflow-hidden">
            <Image
                src={src || "/slang-banner.jpg"}
                alt={alt || "جزیره عطر"}
                layout="fill"
                objectFit="cover"
                className="w-full h-auto max-h-[400px]"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/50">
                <div className='p-5'>
                    <p className="text-white font-bold text-lg md:text-xl lg:text-2xl text-center">
                        {title}
                    </p>
                    {
                        text ?
                            <p className="text-white text-sm md:text-xl lg:text-2xl text-center">
                                {text}
                            </p> :
                            <p className="text-white text-sm md:text-xl lg:text-2xl text-center">
                                {textRandom[Math.floor(Math.random() * textRandom.length)]}
                            </p>
                    }
                </div>
            </div>
        </div>
    );
};

export default DynamicImage;
